import * as React from 'react';
import { CardImage as CardImageComponent } from '../../components/CardImage';
import { TBorderRadius, TImageSizeType, TSizeMap } from './types';

const sizeMap: TSizeMap = {
  XS: { width: '105px', height: '70px' },
  M: { width: '356px', height: '200px' },
  L: { width: '332px', height: '220px' },
};

interface ICardImageProps {
  size?: TImageSizeType;
  src?: string | null;
  borderRadius?: TBorderRadius;
}

/* istanbul ignore next */
export function CardImage({ size, src, borderRadius = '4px' }: ICardImageProps) {
  const imageSize = size && sizeMap[size];

  return (
    <CardImageComponent
      src={src || ''}
      width={imageSize?.width}
      height={imageSize?.height || '200px'}
      borderRadius={borderRadius}
    />
  );
}
